import React from 'react';

import ExpandIcon from '@material-ui/icons/ExpandMore';

import DeleteIcon from '../../../assets/icons/DeleteIcon';
import FileCopyIcon from '../../../assets/icons/CopyIcon';
import ItemIcon from '../../../assets/icons/ItemIcon';
import KitIcon from '../../../assets/icons/KitIcon';
import TitleIcon from '../../../assets/icons/TitleIcon';

import DropdownButton from '../../shared/DropdownButton';
import Button from '../../shared/Button';

import { procedureEquipmentListItemTypes } from '../../../constants/enums';

const dropdownOptions = [
  { id: procedureEquipmentListItemTypes.ITEM.value, label: 'Add Items', icon: <ItemIcon /> },
  { id: procedureEquipmentListItemTypes.KIT.value, label: 'Add Kits', icon: <KitIcon /> },
  { id: procedureEquipmentListItemTypes.TITLE.value, label: 'Add Title', icon: <TitleIcon /> },
];

const EquipmentListsActions = ({ onAddClick, onDeleteClick, selectedEquipmentList, deletePermission, onDuplicateClick }) => {
  return (
    <div className='settings-cmp__filters--main'>
      <div className='settings-cmp__actions'>
        {selectedEquipmentList ? (
          <DropdownButton
            onClick={(option) => onAddClick(option.id)}
            options={dropdownOptions}
          >
            <div className='d-flex m-l-lg'>
              Add
              <ExpandIcon />
            </div>
          </DropdownButton>
        ) : (
          <Button
            text={selectedEquipmentList ? 'Add Step' : 'Add Equipment List'}
            type="submit"
            onClick={onAddClick}
          />
        )}

        <Button
          type='icon'
          onClick={onDeleteClick}
          disabled={!deletePermission}
        >
          <DeleteIcon />
        </Button>

        <Button
          type='icon'
          onClick={onDuplicateClick}
        >
          <FileCopyIcon />
        </Button>
      </div>
    </div>
  );
};

export default EquipmentListsActions;
